export default {
      id: "gallery-play-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#gallery-play",
      toString: function () {
        return this.url;
      }
    }